import { render, staticRenderFns } from "./path-arrow.vue?vue&type=template&id=c1158e82&scoped=true"
import script from "./path-arrow.vue?vue&type=script&lang=js"
export * from "./path-arrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1158e82",
  null
  
)

export default component.exports